import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {AbroadRepresentativeModel} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const ABROAD_REPRESENTATIVE = `${API_URL}/abroad-representative`

export type BulkAction = 'delete' | 'enable' | 'disable'

export const service = {
  getAbroadRepresentative: (params: ParamsModel) => axios.get(ABROAD_REPRESENTATIVE, {params}),
  addAbroadRepresentative: (body: AbroadRepresentativeModel) => axios.post(ABROAD_REPRESENTATIVE, body),
  updateAbroadRepresentative: (body: AbroadRepresentativeModel, id: string) =>
    axios.put(`${ABROAD_REPRESENTATIVE}/${id}`, body),
  bulkAbroadRepresentative: (action: BulkAction, ids: string[]) => {
    const data = {abroadRepresentativeId: ids.map((id) => ({id}))}
    return action === 'delete'
      ? axios.delete(`${ABROAD_REPRESENTATIVE}/bulk-delete`, {data})
      : axios.patch(`${ABROAD_REPRESENTATIVE}/${action}`, data)
  },
}
